import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import SplitPane from "react-split-pane";
import Pagination from "../../../../Pagination";

const FormMetadataReviewActivities = ({
  reviewActivityLoader,
  tableRef,
  onMouseDown,
  getStudyLevelFormReviewHistory,
  metadata,
  formReviewActivity,
  formReviewActivityCount,
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formReviewActivityCount / itemsPerPage);
  useEffect(() => {
    getStudyLevelFormReviewHistory(pageNumber, itemsPerPage);
  }, [metadata, pageNumber, itemsPerPage]);
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {reviewActivityLoader ? (
         <PageLoader/>
        ) : formReviewActivity?.length === 0 ? (
          <NoDataFoundTable MSG={"Form metadata review activity not found"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                  <th
                    style={{ width: 100 }}
                    onMouseDown={(e) => onMouseDown(e, 2)}
                  >
                    Version
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Reviewer Type</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Reviewed By</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>
                    Reviewed Date | Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {formReviewActivity?.map((item, index) => (
                  <tr>
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td>{metadata?.formName}</td>
                    <td>{item?.version}</td>
                    <td>Reviewed</td>
                    <td>
                      {item?.mode === "DBP Mode" ? "Designer" : "Validator"}
                    </td>
                    <td>{item?.reviewedBy}</td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={formReviewActivityCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default FormMetadataReviewActivities;
